<confirmaciongenerica #appconfirmacion (ConfirmoUsuario)="ConfirmoUsuario($event)" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></confirmaciongenerica>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">{{this.TituloOpcionMenu()}}</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>
    <div class="d-flex justify-content-between flex-wrap filtrosTable align-items-center" autocomplete="off">
        <div [formGroup]="form" class="d-flex flex-wrap" autocomplete="off">
            <div class="p-1">
                <h2>Aquí los datos del <br/> afiliado</h2>
            </div>
            <div class="p-1">
                <mat-form-field appearance="fill">
                    <mat-label>Número de identificación (*)</mat-label>
                    <input matInput formControlName="nroIdentificacion" autocomplete="off" (keyup.enter)="ConsultarRegistros()">
                    <button (click)="ConsultarRegistros()" mat-icon-button matSuffix type="button">
                        <mat-icon>search</mat-icon>
                    </button>
                </mat-form-field>
            </div>
            <div class="p-1">
                <mat-form-field appearance="fill">
                    <mat-label>Nombre (*)</mat-label>
                    <input matInput formControlName="nombres" autocomplete="off" (keyup.enter)="ConsultarRegistros()">
                    <button (click)="ConsultarRegistros()" mat-icon-button matSuffix type="button">
                        <mat-icon>search</mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </div>
        <div>
            <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
        </div>
    </div>
    <div class="pl-0 pr-0 mat-elevation-z8">
        <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" matSort class="table table-striped table-hover">

                <!-- nroDocumento Column -->
                <ng-container matColumnDef="nroDocumento">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Identificación </th>
                    <td mat-cell *matCellDef="let row"> {{row.nroDocumento}} </td>
                </ng-container>
                <!-- descripcionEstado Column -->
                <ng-container matColumnDef="descripcionEstado">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado</th>
                    <td mat-cell *matCellDef="let row">
                        <span *ngIf="row.estado === 'FINISH'" class="txtActivo">{{row.descripcionEstado}}</span>
                        <span *ngIf="row.estado === 'REJECT' || row.estado === 'BLOCKED'" class="txtInactivo">{{row.descripcionEstado}}</span>
                        <span *ngIf="row.estado !== 'FINISH' && row.estado !== 'REJECT' && row.estado !== 'BLOCKED'" class="txtBloqueado">{{row.descripcionEstado}}</span>
                    </td>
                </ng-container>
                <!-- fechaCreacion Column -->
                <ng-container matColumnDef="fechaCreacion">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha creación </th>
                    <td mat-cell *matCellDef="let row"> {{row.fechaCreacion | fechapipe}} </td>
                </ng-container>
                <!-- nombreCompleto Column -->
                <ng-container matColumnDef="nombreCompleto">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre y apellido </th>
                    <td mat-cell *matCellDef="let row"> {{row.nombreCompleto}} </td>
                </ng-container>
                <!-- descripcionProducto Column -->
                <ng-container matColumnDef="descripcionProducto">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Producto </th>
                    <td mat-cell *matCellDef="let row"> {{row.descripcionProducto}} </td>
                </ng-container>
                <!-- tipoFirmaElectronica Column -->
                <ng-container matColumnDef="tipoFirmaElectronica">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo firma </th>
                    <td mat-cell *matCellDef="let row"> {{row.tipoFirmaElectronica === 'PROPIO' ? 'OTP' : row.tipoFirmaElectronica}} </td>
                </ng-container>
                <!-- acciones Column -->
                <ng-container matColumnDef="acciones">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Acciones </th>
                    <td mat-cell *matCellDef="let row">
                        <a type="button" class="icnTable" (click)="refrescarDetalle(row)" *ngIf="HabilitarOpcionesEdicion() && this.TipoFirmaAuco(row)">
                            <mat-icon>refresh</mat-icon>
                        </a>
                        <a type="button" class="icnTable" (click)="eliminarDetalle(row)" *ngIf="HabilitarOpcionesEdicion()">
                            <mat-icon>delete</mat-icon>
                        </a>
                        <a type="button" class="icnTable" (click)="descargarDocumento(row)" *ngIf="MostrarDescargarDocumento(row) && HabilitarOpcionesEdicion()">
                            <mat-icon>cloud_download</mat-icon>
                        </a>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnasEncabezado"></tr>
                <tr mat-row *matRowDef="let row; columns: columnasEncabezado;"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                </tr>
            </table>
        </div>
    </div>
</div>